import type { AlgoliaResponseDTO } from './AlgoliaResponseDTO.js'
import type { SearchResponse } from '../../domain/search/SearchModels.js'

/**
 * Translates the raw Algolia proxy response into the engine-agnostic domain model.
 *
 * This is the only place that maps vendor field names to domain field names:
 *   objectID → id
 *   image    → imageUrl
 *   type     → contentType
 */
export function normalizeAlgoliaResponse(dto: AlgoliaResponseDTO): SearchResponse {
  return {
    suggestions: (dto.suggestions ?? []).map((s) => ({
      query: s.query,
      popularity: s.popularity,
    })),
    results: (dto.results ?? []).map((r) => ({
      id: r.objectID,
      title: r.title ?? '',
      url: r.url ?? '',
      description: r.description,
      imageUrl: r.image,
      contentType: r.type,
    })),
  }
}
